import React from 'react'
import type { PublicRequestOccasion } from 'apollo-gql'
import { BodySmallBold } from 'stories/UI/Typography/BodySmallBold.stories'

import { Button } from 'components/UI/Button/Button'
import IconFromName from 'components/UI/Icon/IconFromName'

import styles from './Occasion.module.css'

type OccasionProps = {
  occasion: PublicRequestOccasion
  isSelected: boolean
  onChange: (selectedId: string) => void
}

const Occasion = ({
  occasion,
  isSelected,
  onChange,
}: OccasionProps): JSX.Element => (
  <div className={styles.buttonWrapper}>
    <Button
      onClick={() => {
        onChange(occasion.id)
      }}
      size="small"
      type="option"
      selected={isSelected}
      data-cy="occasionOption"
      noMinWidth
    >
      <div className={styles.buttonContent}>
        <div className={styles.iconWrapper}>
          <IconFromName name={occasion.icon} />
        </div>

        <BodySmallBold>{occasion.title}</BodySmallBold>
      </div>
    </Button>
  </div>
)

export default Occasion
